export default __webpack_public_path__ + "static/media/third.ea35ee84.png";